// Fiche produit Amira : quantité au-dessus des offres, offres à choix (pièce seule / lot), paiement direct
// et ligne Tabby.
// - La quantité affichée (bloc amira-addon) pilote le sélecteur d'Horizon, masqué dans le formulaire d'achat.
// - Lot choisi : la pièce assortie est ajoutée au panier juste avant l'ajout d'Horizon, si bien que le tiroir
//   du panier montre les deux pièces avec la remise automatique déjà appliquée.
// - « Paiement direct » (sans Apple Pay ni Google Pay) : lien panier Shopify vers le paiement avec les pièces choisies.
// - Ligne Tabby : le montant des 4 paiements suit l'offre et la quantité ; un clic ouvre la fenêtre d'explication.
const MAX_QTY = 20;

const buybox = () => document.querySelector('[data-amira-buybox]');
const bundle = () => document.querySelector('[data-amira-bundle]');
const productForm = () => document.querySelector('product-form-component form');
const setChosen = () => Boolean(bundle()?.querySelector('input:is([value="set"], [value="full"]):checked'));
// Offre cochée : lot = la pièce assortie s'ajoute à la pièce principale ; lot complet = la pièce assortie et la
// seconde pièce s'y ajoutent. La pièce principale reste celle de la fiche, donc Apple Pay / Google Pay fonctionnent.
function chosenOffer() { return bundle()?.querySelector('input:checked')?.value || 'single'; }
function extraVariants() {
  const offer = chosenOffer();
  if (offer === 'four') return [bundle().dataset.addonVariant, bundle().querySelector('input[value="full"]').dataset.extraVariant, bundle().querySelector('input[value="four"]').dataset.fourVariant];
  if (offer === 'set') return [bundle().dataset.addonVariant];
  if (offer === 'alt') return [bundle().querySelector('input[value="alt"]').dataset.altVariant];
  if (offer === 'full') return [bundle().dataset.addonVariant, bundle().querySelector('input[value="full"]').dataset.extraVariant];
  return [];
}

function quantity() {
  const input = buybox()?.querySelector('[data-qty-input]');
  const n = Math.round(Number(input?.value));
  return Number.isFinite(n) && n >= 1 ? Math.min(n, MAX_QTY) : 1;
}

function money(cents) {
  const format = buybox()?.dataset.moneyFormat || document.querySelector('[data-money-format]')?.dataset.moneyFormat || '{[amount]}';
  const amount = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
}

// Lots dans une autre devise que l'AED (marchés UK, International…) : les remises du lot sont des montants fixes en AED
// que Shopify convertit au panier au taux Shopify.currency.rate (arrondi au centime). On fait le même calcul ici pour que
// la fiche affiche exactement le prix du panier ; la fiche masque ces prix (data-fx-hide) tant que ce calcul n'est pas fait.
function fxMoney(cents) {
  // Même format que les prix de Shopify dans cette devise, lu sur un exemple rendu par la fiche (1 234 567,89).
  const sample = document.querySelector('[data-amira-bundle][data-fx]')?.dataset.moneySample || '';
  const m = sample.match(/^(.*?)1(\D?)234(\D?)567(\D?)89(.*)$/s);
  if (!m) return money(cents);
  const [, prefix, thousands, , decimal, suffix] = m;
  const [int, dec] = (Math.abs(cents) / 100).toFixed(2).split('.');
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
  return `${cents < 0 ? '-' : ''}${prefix}${grouped}${decimal}${dec}${suffix}`;
}
function convertBundleFx() {
  const box = document.querySelector('[data-amira-bundle][data-fx]');
  const rate = Number(window.Shopify?.currency?.rate);
  if (!box || !(rate > 0)) return;
  const main = Number(box.dataset.mainPrice);
  const addon = Number(box.dataset.addonPrice);
  // Prix barré de la pièce (compare_at) : base des pourcentages et de « You save », comme sur la fiche en AED.
  const mainCompare = Math.max(Number(box.dataset.mainCompare) || main, main);
  const saved = (el, cents) => { if (el) el.textContent = el.dataset.label.replace('[amount]', fxMoney(cents)); };
  const off = (aed) => Math.round(Number(aed) * 100 * rate); // remise convertie, en centimes de la devise affichée
  const set = box.querySelector('input[value="set"][data-off-aed]');
  if (set) {
    const addonSet = addon - off(set.dataset.offAed);
    set.dataset.total = String(main + addonSet);
    box.querySelector('[data-fx-set-total]').textContent = fxMoney(main + addonSet);
    box.querySelector('[data-fx-addon-set]').textContent = fxMoney(addonSet);
  }
  const full = box.querySelector('input[value="full"][data-off-aed]');
  if (full) {
    const extra = Number(full.dataset.extraPrice);
    const cut = off(full.dataset.offAed);
    const total = main + (addon - cut) + (extra - cut);
    const pct = Math.round(((mainCompare + addon + extra - total) * 100) / (mainCompare + addon + extra)); // sur le total des pièces
    full.dataset.total = String(total);
    box.querySelector('[data-fx-full-total]').textContent = fxMoney(total);
    box.querySelector('[data-fx-addon-full]').textContent = fxMoney(addon - cut);
    box.querySelector('[data-fx-extra-full]').textContent = fxMoney(extra - cut);
    const badge = box.querySelector('[data-fx-full-badge]');
    if (badge) badge.textContent = `−${pct}%`;
    const sub = box.querySelector('[data-fx-full-sub]');
    if (sub) sub.textContent = sub.dataset.template.replace('%%', pct);
    saved(box.querySelector('[data-fx-full-save]'), mainCompare + addon + extra - total);
    const four = box.querySelector('input[value="four"][data-off-aed]');
    if (four) {
      const piece = Number(four.dataset.fourPrice);
      const fourTotal = total + piece - off(four.dataset.offAed);
      four.dataset.total = String(fourTotal);
      box.querySelector('[data-fx-four-total]').textContent = fxMoney(fourTotal);
      const fb = box.querySelector('[data-fx-four-badge]');
      if (fb) fb.textContent = `−${Math.round(((mainCompare + addon + extra + piece - fourTotal) * 100) / (mainCompare + addon + extra + piece))}%`;
      saved(box.querySelector('[data-fx-four-save]'), mainCompare + addon + extra + piece - fourTotal);
    }
  }
  const alt = box.querySelector('input[value="alt"][data-off-aed]');
  if (alt) {
    const altPrice = Number(alt.dataset.altPrice);
    const cut = off(alt.dataset.offAed);
    const pct = Math.floor((cut * 100) / altPrice);
    alt.dataset.total = String(main + altPrice - cut);
    box.querySelector('[data-fx-alt-total]').textContent = fxMoney(main + altPrice - cut);
    box.querySelector('[data-fx-alt-set]').textContent = fxMoney(altPrice - cut);
    const badge = box.querySelector('[data-fx-alt-badge]');
    if (badge) badge.textContent = `−${pct}%`;
    const sub = box.querySelector('[data-fx-alt-sub]');
    if (sub) sub.textContent = sub.dataset.template.replace('%%', pct);
  }
  for (const el of box.querySelectorAll('[data-fx-hide]')) el.removeAttribute('data-fx-hide');
}
convertBundleFx();

// Montant total choisi (offre × quantité) ; sans bloc d'offres, prix de la pièce porté par la ligne Tabby.
function refreshTabby() {
  const tabby = document.querySelector('.am-tabby--product');
  if (!tabby) return;
  const chosen = bundle()?.querySelector('input:checked');
  const unit = chosen ? Number(chosen.dataset.total) : Number(tabby.dataset.unitCents);
  if (!unit) return;
  const quarter = Math.floor((unit * quantity()) / 4);
  for (const el of tabby.querySelectorAll('[data-tabby-quarter]')) el.textContent = money(quarter);
}

// Le formulaire d'achat suit l'offre cochée, pour Horizon comme pour Apple Pay / Google Pay (qui lisent ce formulaire
// au clic) : les pièces en plus sont déclarées en « shopify-additional-items », que les boutons de paiement express
// achètent avec la pièce principale.
function syncForm() {
  const form = productForm();
  if (!form || !bundle()) return;
  const idInput = form.querySelector('input[name="id"]');
  idInput.dataset.mainVariant ??= idInput.value;
  idInput.value = idInput.dataset.mainVariant;
  for (const el of form.querySelectorAll('[data-amira-additional]')) el.remove();
  extraVariants().forEach((id, i) => {
    for (const [key, value] of [['id', id], ['quantity', quantity()]]) {
      const input = Object.assign(document.createElement('input'), { type: 'hidden', name: `shopify-additional-items[${i + 1}][${key}]`, value: String(value) });
      input.dataset.amiraAdditional = '';
      form.appendChild(input);
    }
  });
}

function syncQuantity() {
  const box = buybox();
  if (!box) return;
  const input = box.querySelector('[data-qty-input]');
  const n = quantity();
  input.value = String(n);
  const selector = document.querySelector('product-form-component quantity-selector-component');
  if (selector && typeof selector.setValue === 'function') selector.setValue(String(n));
  else {
    const native = productForm()?.querySelector('input[name="quantity"]');
    if (native) native.value = String(n);
  }
  syncForm();
  refreshTabby();
}

document.addEventListener('click', (event) => {
  const target = /** @type {HTMLElement} */ (event.target);

  const step = target.closest('[data-qty-step]');
  if (step) {
    const input = buybox()?.querySelector('[data-qty-input]');
    if (input) input.value = String(Math.max(1, Math.min(MAX_QTY, quantity() + Number(step.dataset.qtyStep))));
    syncQuantity();
    return;
  }

  const open = target.closest('[data-tabby-open]');
  if (open) {
    open.closest('[data-amira-tabby]')?.querySelector('dialog')?.showModal();
    return;
  }

  const dialog = target.closest('dialog[data-tabby-dialog]');
  if (dialog && target === dialog) dialog.close(); // clic sur le fond

  const express = target.closest('[data-amira-express]');
  if (express) {
    event.preventDefault();
    const form = productForm();
    const variant = form?.querySelector('input[name="id"]')?.value || document.querySelector('.am-express [data-variant]')?.dataset.variant;
    if (!variant) return;
    const n = quantity();
    const lines = [`${variant}:${n}`];
    for (const id of extraVariants()) lines.push(`${id}:${n}`);
    const root = window.Shopify?.routes?.root || '/';
    window.location.href = `${root}cart/${lines.join(',')}`;
  }
});

document.addEventListener('change', (event) => {
  const target = /** @type {HTMLElement} */ (event.target);
  if (target.matches?.('[data-qty-input]')) syncQuantity();
  if (target.closest?.('[data-amira-bundle]')) { syncForm(); refreshTabby(); }
});

window.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.closest('product-form-component')) return;
  for (const el of form.querySelectorAll('[data-amira-item]')) el.remove();
  const extras = extraVariants();
  if (!extras.length) return;

  // Une seule requête (2026-10-23, avant : 2 ajouts à la suite, ~0,7 s de plus) : Horizon envoie la pièce principale
  // (champ id) et Shopify ajoute dans le même appel les pièces du lot passées en items[] ; le tiroir du panier revient
  // déjà rendu avec toutes les pièces et la remise.
  const n = Number(new FormData(form).get('quantity')) || 1;
  extras.forEach((id, i) => {
    for (const [key, value] of [['id', id], ['quantity', n]]) {
      const input = Object.assign(document.createElement('input'), { type: 'hidden', name: `items[${i}][${key}]`, value: String(value) });
      input.dataset.amiraItem = '';
      form.appendChild(input);
    }
  });
  // Les champs du paiement express (shopify-additional-items) ne partent pas avec l'ajout au panier.
  const additional = [...form.querySelectorAll('[data-amira-additional]')];
  for (const el of additional) el.disabled = true;
  setTimeout(() => {
    for (const el of additional) el.disabled = false;
    for (const el of form.querySelectorAll('[data-amira-item]')) el.remove();
  }, 0);
}, true);

syncForm();

// Apple Pay / Google Pay : si aucun des deux n'apparaît (appareil sans portefeuille), le bouton Shopify
// « Buy it now » reste masqué et notre « paiement direct » prend sa place (classe am-no-wallet).
// Présence du bouton (pas sa hauteur : masqué par am-no-wallet, il mesure 0) ; on guette 10 s pour les téléphones lents.
function walletReady() {
  return Boolean(document.querySelector('.accelerated-checkout-block :is(shopify-apple-pay-button, shopify-google-pay-button)'));
}
if (document.querySelector('.am-express:not(.lip .am-express)')) {
  const started = Date.now();
  const timer = setInterval(() => {
    if (walletReady()) { document.body.classList.remove('am-no-wallet'); clearInterval(timer); return; }
    if (Date.now() - started > 2500) document.body.classList.add('am-no-wallet');
    if (Date.now() - started > 10000) clearInterval(timer);
  }, 250);
}

refreshTabby();

// Comptes à rebours de l'offre limitée (bloc amira-addon, panier) : tous les chronos de la page, y compris ceux que le
// tiroir du panier ajoute en se mettant à jour ; à l'échéance, les étiquettes et les bandeaux disparaissent.
const pad = (n) => String(n).padStart(2, '0');
const tickCountdowns = () => {
  for (const countdown of document.querySelectorAll('.am-countdown[data-offer-ends]')) {
    const left = Math.max(0, Math.floor((Number(countdown.dataset.offerEnds) * 1000 - Date.now()) / 1000));
    if (!left) {
      for (const el of document.querySelectorAll(`[data-offer-ends="${countdown.dataset.offerEnds}"]`)) el.hidden = true;
      continue;
    }
    const days = Math.floor(left / 86400);
    countdown.querySelector('[data-cd-days]').hidden = !days;
    countdown.querySelector('[data-cd="d"]').textContent = days;
    countdown.querySelector('[data-cd="h"]').textContent = pad(Math.floor((left % 86400) / 3600));
    countdown.querySelector('[data-cd="m"]').textContent = pad(Math.floor((left % 3600) / 60));
    countdown.querySelector('[data-cd="s"]').textContent = pad(left % 60);
  }
};
setInterval(tickCountdowns, 1000);
tickCountdowns();
